export default "__VITE_ASSET__D72hDLZx__"